"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slack = void 0;
const TENANT_COLLECTION = "$tenants";
function removeNullKeys(obj) {
    Object.keys(obj).forEach((key) => {
        if (obj[key] === null) {
            delete obj[key];
        }
    });
    return obj;
}
class Slack {
    constructor(knock) {
        this.knock = knock;
    }
    getChannels(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const { knockChannelId, tenant } = input;
            const queryOptions = input.queryOptions || {};
            const params = {
                access_token_object: {
                    object_id: tenant,
                    collection: TENANT_COLLECTION,
                },
                channel_id: knockChannelId,
                query_options: removeNullKeys({
                    cursor: queryOptions.cursor || null,
                    limit: queryOptions.limit || null,
                    exclude_archived: queryOptions.excludeArchived || null,
                    team_id: queryOptions.teamId || null,
                    types: queryOptions.types || null,
                }),
            };
            const { data } = yield this.knock.get(`/v1/providers/slack/${knockChannelId}/channels`, params);
            return data;
        });
    }
    authCheck({ tenant, knockChannelId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                access_token_object: {
                    object_id: tenant,
                    collection: TENANT_COLLECTION,
                },
                channel_id: knockChannelId,
            };
            const { data } = yield this.knock.get(`/v1/providers/slack/${knockChannelId}/auth_check`, params);
            return data;
        });
    }
    revokeAccessToken({ tenant, knockChannelId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                access_token_object: {
                    object_id: tenant,
                    collection: TENANT_COLLECTION,
                },
                channel_id: knockChannelId,
            };
            const { data } = yield this.knock.get(`/v1/providers/slack/${knockChannelId}/revoke_access`, params);
            return data;
        });
    }
}
exports.Slack = Slack;
